import { render, staticRenderFns } from "./animation-spinner.vue?vue&type=template&id=f405ef8e"
import script from "./animation-spinner.vue?vue&type=script&lang=js"
export * from "./animation-spinner.vue?vue&type=script&lang=js"
import style0 from "./animation-spinner.vue?vue&type=style&index=0&id=f405ef8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports